import { useState, useEffect } from 'react';

import Auth from '../auth';
import { useSignInEvent, useSetNullOnSignOut } from './events';

function useAuthUserInfo() {
  const [authUserInfo, setAuthUserInfo] = useState();

  useEffect(() => {
    let active = true;

    (async () => {
      const info = await Auth.currentUserInfo();
      if (!active) {
        return;
      }
      
      setAuthUserInfo(info);
    })();

    return () => {
      active = false;
    };
  }, [authUserInfo, setAuthUserInfo]);

  return authUserInfo;
}

export function useAuthUser() {
  const [authUser, setAuthUser] = useState();
  useSignInEvent(setAuthUser);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();

        if (!active) {
          return;
        }

        setAuthUser(user);
      } catch {
        setAuthUser(null);
      }
    })();

    return () => {
      active = false;
    };
  }, [setAuthUser]);
  useSetNullOnSignOut(setAuthUser);

  return authUser;
}